export class Events {

    constructor(options) {
        this.options = { ...{analytics: {}}, ...options };
    }

    /**
     * Visit page event
     *
     * @param params
     */
    onPageLoad(params) {
        if (_.has(params, 'page')) {
            for (let analytic in this.options.analytics) {
                if (typeof (this.options.analytics[analytic]['onPageLoad']) == 'function') {
                    if (process.env.MIX_APP_DEBUG === 'false') {
                        this.options.analytics[analytic].onPageLoad(params);
                    } else {
                        console.log('onPageLoad', params);
                        break;
                    }
                }
            }
        }
    }

    /**
     * Fire after product card visible
     *
     * @param params
     */
    onLoadImpressions(params) {
        if (_.has(params, 'products')) {
            for (let analytic in this.options.analytics) {
                if (typeof (this.options.analytics[analytic]['onLoadImpressions']) == 'function') {
                    if (process.env.MIX_APP_DEBUG === 'false') {
                        this.options.analytics[analytic].onLoadImpressions(params.products);
                    } else {
                        console.log('onLoadImpressions', params.products);
                        break;
                    }
                }
            }
        }
    }

    /**
     * Fire after product page visit
     *
     * @param params
     */
    onLoadDetail(params) {
        if (_.has(params, 'product')) {
            for (let analytic in this.options.analytics) {
                if (typeof (this.options.analytics[analytic]['onLoadDetail']) == 'function') {
                    if (process.env.MIX_APP_DEBUG === 'false') {
                        this.options.analytics[analytic].onLoadDetail(params.product);
                    } else {
                        console.log('onLoadDetail', params.product);
                        break;
                    }
                }
            }
        }
    }

    /**
     * Subscribe event
     */
    onSubscribe() {
        for (let analytic in this.options.analytics) {
            if (typeof (this.options.analytics[analytic]['onSubscribe']) == 'function') {
                if (process.env.MIX_APP_DEBUG === 'false') {
                    this.options.analytics[analytic].onSubscribe();
                } else {
                    console.log('onSubscribe');
                    break;
                }
            }
        }
    }

    /**
     * On click product card event
     *
     * @param params
     */
    onClickProduct(params) {
        if (_.has(params, 'product')) {
            for (let analytic in this.options.analytics) {
                if (typeof (this.options.analytics[analytic]['onClickProduct']) == 'function') {
                    if (process.env.MIX_APP_DEBUG === 'false') {
                        this.options.analytics[analytic].onClickProduct(params.product);
                    } else {
                        console.log('onClickProduct', params.product);
                        break;
                    }
                }
            }
        }
    }

    /**
     * On click on the cart link
     */
    onClickCart(position) {
        for (let analytic in this.options.analytics) {
            if (typeof (this.options.analytics[analytic]['onClickCart']) == 'function') {
                if (process.env.MIX_APP_DEBUG === 'false') {
                    this.options.analytics[analytic].onClickCart(position);
                } else {
                    console.log('onClickCart', position);
                    break;
                }
            }
        }
    }

    /**
     * On click on the buy button
     */
    onClickBuy(position) {
        for (let analytic in this.options.analytics) {
            if (typeof (this.options.analytics[analytic]['onClickBuy']) == 'function') {
                if (process.env.MIX_APP_DEBUG === 'false') {
                    this.options.analytics[analytic].onClickBuy(position);
                } else {
                    console.log('onClickBuy', position);
                    break;
                }
            }
        }
    }

    /**
     * On go to registration
     */
    onClickRegister() {
        for (let analytic in this.options.analytics) {
            if (typeof (this.options.analytics[analytic]['onClickRegister']) == 'function') {
                if (process.env.MIX_APP_DEBUG === 'false') {
                    this.options.analytics[analytic].onClickRegister();
                } else {
                    console.log('onClickRegister');
                    break;
                }
            }
        }
    }

    /**
     * On click on the register button
     */
    onClickRegistered() {
        for (let analytic in this.options.analytics) {
            if (typeof (this.options.analytics[analytic]['onClickRegistered']) == 'function') {
                if (process.env.MIX_APP_DEBUG === 'false') {
                    this.options.analytics[analytic].onClickRegistered();
                } else {
                    console.log('onClickRegistered');
                    break;
                }
            }
        }
    }

    /**
     * On click on the phone number
     */
    onClickPhone() {
        for (let analytic in this.options.analytics) {
            if (typeof (this.options.analytics[analytic]['onClickPhone']) == 'function') {
                if (process.env.MIX_APP_DEBUG === 'false') {
                    this.options.analytics[analytic].onClickPhone();
                } else {
                    console.log('onClickPhone');
                    break;
                }
            }
        }
    }

    /**
     * Add to cart event
     *
     * @param params
     */
    onAddToCart(params) {
        if (_.has(params, 'product')) {
            for (let analytic in this.options.analytics) {
                if (typeof (this.options.analytics[analytic]['onAddToCart']) == 'function') {
                    if (process.env.MIX_APP_DEBUG === 'false') {
                        this.options.analytics[analytic].onAddToCart(params.product);
                    } else {
                        console.log('onAddToCart', params.product);
                        break;
                    }
                }
            }
        }
    }

    /**
     * Remove from cart event
     *
     * @param params
     */
    onRemoveFromCart(params) {
        if (_.has(params, 'products')) {
            for (let analytic in this.options.analytics) {
                if (typeof (this.options.analytics[analytic]['onRemoveFromCart']) == 'function') {
                    if (process.env.MIX_APP_DEBUG === 'false') {
                        this.options.analytics[analytic].onRemoveFromCart(params.products);
                    } else {
                        console.log('onRemoveFromCart', params.products);
                        break;
                    }
                }
            }
        }
    }

    onCheckout(params) {
        if (_.has(params, 'step') && _.has(params, 'products')) {
            for (let analytic in this.options.analytics) {
                if (typeof (this.options.analytics[analytic]['onCheckout']) == 'function') {
                    if (process.env.MIX_APP_DEBUG === 'false') {
                        this.options.analytics[analytic].onCheckout(params.step, params.products);
                    } else {
                        console.log('onCheckout', params.step, params.products);
                        break;
                    }
                }
            }
        }
    }

    /**
     * After successfully purchase
     *
     * @param params
     */
    onPurchased(params) {
        if (_.has(params, 'order') && _.has(params, 'products')) {
            for (let analytic in this.options.analytics) {
                if (typeof (this.options.analytics[analytic]['onPurchased']) == 'function') {
                    if (process.env.MIX_APP_DEBUG === 'false') {
                        this.options.analytics[analytic].onPurchased(params.order, params.products);
                    } else {
                        console.log('onPurchased', params.order, params.products);
                        break;
                    }
                }
            }
        }
    }

    /**
     * After successfully purchase
     *
     * @param params
     */
    onThankYouPage(params) {
        if (_.has(params, 'order')) {
            for (let analytic in this.options.analytics) {
                if (typeof (this.options.analytics[analytic]['onThankYouPage']) == 'function') {
                    if (process.env.MIX_APP_DEBUG === 'false') {
                        this.options.analytics[analytic].onThankYouPage(params.order);
                    } else {
                        console.log('onThankYouPage', params.order);
                        break;
                    }
                }
            }
        }
    }

    /**
     * On apply promo code
     */
    onApplyPromoCode() {
        for (let analytic in this.options.analytics) {
            if (typeof (this.options.analytics[analytic]['onApplyPromoCode']) == 'function') {
                if (process.env.MIX_APP_DEBUG === 'false') {
                    this.options.analytics[analytic].onApplyPromoCode();
                } else {
                    console.log('onApplyPromoCode');
                    break;
                }
            }
        }
    }

    onOneClickOpen() {
        for (let analytic in this.options.analytics) {
            if (typeof (this.options.analytics[analytic]['onOneClickOpen']) == 'function') {
                if (process.env.MIX_APP_DEBUG === 'false') {
                    this.options.analytics[analytic].onOneClickOpen();
                } else {
                    console.log('onOneClickOpen');
                    break;
                }
            }
        }
    }

    onOneClickPurchased(params) {
        for (let analytic in this.options.analytics) {
            if (typeof (this.options.analytics[analytic]['onOneClickPurchased']) == 'function') {
                if (process.env.MIX_APP_DEBUG === 'false') {
                    this.options.analytics[analytic].onOneClickPurchased(params);
                } else {
                    console.log('onOneClickPurchased');
                    break;
                }
            }
        }
    }

    onLocationUndefined() {
        for (let analytic in this.options.analytics) {
            if (typeof (this.options.analytics[analytic]['onLocationUndefined']) == 'function') {
                if (process.env.MIX_APP_DEBUG === 'false') {
                    this.options.analytics[analytic].onLocationUndefined();
                } else {
                    console.log('onLocationUndefined');
                    break;
                }
            }
        }
    }
}
